import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';
import AuthLayout from 'layout/Auth';
import { PublicRoute } from 'routes/RouteGuards';

const LoginPage = Loadable(lazy(() => import('views/auth/Login')));

const PagesRoutes = {
  path: '/',
  element: <PublicRoute />,
  children: [
    {
      element: <AuthLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="/login" replace />
        },
        {
          path: 'login',
          element: <LoginPage />
        }
      ]
    }
  ]
};

export default PagesRoutes;
